<template>
  <section class="mt-12">
    <h4 class="fs-20 font-medium mb-4">Conservation</h4>

    <checkbox v-model="options.conservationOptions.greenfin"
      @change="$emit('filter-changed')">
      Green Fins member
    </checkbox>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Checkbox from '../../core/Checkbox'

export default {
  components: {
    Checkbox
  },
  inject: ['options']
}
</script>